<ng-container *transloco="let t">
  @if (title) {
    <label class="msi-label loading-dialog__title">{{ title }}</label>
  }
  <div class="loading-dialog__body">
    @if (message) {
      <p>{{ message }}</p>
    }
    <p-progress-spinner />
  </div>
</ng-container>
